import { Injectable } from '@angular/core';
import { action, computed, observable } from 'mobx-angular';
import { BaseStore } from './base.store';
import { WindowStore } from './window.store';

@Injectable({
  providedIn: 'root',
})
export class SidebarStore extends BaseStore {
  @observable
  _showSidebar = true;
  @observable
  showMobileSidebar = false;

  @action
  toggleSidebar = (value = !this._showSidebar) => {
    this.showMobileSidebar = false;
    this._showSidebar = value;
  };

  @action
  toggleMobileSidebar = (value = !this.showMobileSidebar) => {
    this.showMobileSidebar = value;
  };

  @computed
  get showSidebar(): boolean {
    return this.windowStore.window.matchMedia('(max-width: 1366px)').matches
      ? this.showMobileSidebar
      : this._showSidebar;
  }

  constructor(readonly windowStore: WindowStore) {
    super();
  }
}
